import { Box, TextField, TextFieldSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface TextFieldSizeProps {
  changed?: boolean;
  disabled?: boolean;
}
export const ContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pt: { sm: '500' },
  pr: { sm: '400' },
  pb: { sm: '550' },
  pl: { sm: '400' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[50]};
    width: 100%;
  `}
`;

export const MarkContainerStyled = styled(Box).attrs({
  mr: { sm: '400' },
  ml: { sm: '450' },
  p: { sm: '400' },
})`
  ${({ theme }) => css`
    flex-shrink: 0;
    border-radius: ${theme.radii[200]};
    background-color: white;
    border: 1px dashed ${theme.colors.grey[400]};
  `}
`;

export const TextFieldStyled = styled(TextField).attrs({
  size: TextFieldSize.SMALL,
})<TextFieldSizeProps>`
  ${({ theme }) => css`
    height: 26px;
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.black};
    background-color: ${theme.colors.white};
    border-radius: 0 ${theme.spacings[200]} ${theme.spacings[200]} 0;

    &:focus {
      border-color: transparent;
      box-shadow: none;
    }
  `}
  ${({ changed }) =>
    changed &&
    css`
      background-color: ${({ theme }) => theme.colors.blue[100]};
    `}

    ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.grey[100]};
      opacity: 0.5;
    `}
`;

export const ContainerBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '450' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border: 1px solid ${theme.colors.grey[200]};
    border-radius: ${theme.radii[200]};
  `};
`;

export const BoxStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  py: { sm: '300' },
})`
  position: relative;
  top: 5%;
`;
